"use client";

import { c as _c } from "react/compiler-runtime";
import MemesWaveQuickVoteTrigger from "../left-sidebar/waves/MemesWaveQuickVoteTrigger";
import { useMemesWaveFooterStats } from "@/hooks/useMemesWaveFooterStats";
interface FloatingMemesQuickVoteTriggerProps {
  readonly onOpenQuickVote: () => void;
  readonly onPrefetchQuickVote?: (() => void) | undefined;
}
export default function FloatingMemesQuickVoteTrigger(t0) {
  const $ = _c(4);
  const {
    onOpenQuickVote,
    onPrefetchQuickVote
  } = t0;
  const {
    isReady,
    uncastPower,
    unratedCount
  } = useMemesWaveFooterStats();
  if (!isReady || typeof uncastPower !== "number" || unratedCount <= 0) {
    return null;
  }
  let t1;
  if ($[0] !== onOpenQuickVote || $[1] !== onPrefetchQuickVote || $[2] !== unratedCount) {
    t1 = <div className="tw-absolute tw-right-2 tw-top-2 tw-z-20 sm:tw-right-4 sm:tw-top-3"><MemesWaveQuickVoteTrigger onOpenQuickVote={onOpenQuickVote} onPrefetchQuickVote={onPrefetchQuickVote} unratedCount={unratedCount} /></div>;
    $[0] = onOpenQuickVote;
    $[1] = onPrefetchQuickVote;
    $[2] = unratedCount;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}